/* eslint-disable max-len */
// Dependencies
import React, {useState} from 'react'
import {connect} from 'react-redux'

// import Helpers from '../Helpers.js'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesUserFeedback from '../styles/UserFeedback.module.css'
import {Icon, Input} from '@lazarusai/forms-ui-components'

// Components

function UserFeedback({
  question = '',
  onAnswerSubmit = (answer) => {},
  ...props
}) {
  const [answer, setAnswer] = useState('')

  return (
    <div
      className={stylesUserFeedback['feedback-wrapper']}
    >
      <div
        className={stylesUserFeedback['feedback-header']}
      >
        <Icon
          icon='question-mark-circle'
        />
        <div>
          {question}
        </div>
      </div>
      <div
        className={stylesUserFeedback['feedback-input']}
      >
        <Input
          minHeight={36}
          maxHeight={120}
          type={2}
          isAutoResizing={true}
          onChange={(e) => setAnswer(e.target.value)}
          value={answer}
          theme={props.theme}
        />
        <Icon
          icon='paper-plane'
          onClick={() => {
            onAnswerSubmit(answer)
          }}
        />
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(UserFeedback)
